import { MILES_KM } from 'utils/constants';

function distanceString(distance, units, digits = 1) {
  const factor = units === 'km' ? 1 : MILES_KM;
  return (distance * factor).toFixed(digits);
}

export default distanceString;
